import { motion } from "framer-motion";
import { Flag, Cpu, Rocket, Users } from "lucide-react";

const stats = [
    { label: "Founder Status", value: "US Veteran", icon: Flag },
    { label: "Mission", value: "Post-Scarcity", icon: Rocket },
    { label: "Core Focus", value: "Real Engineering", icon: Cpu },
    { label: "Working Model", value: "Open Source", icon: Users },
];

export default function About() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="relative bg-[#F4F4F5] py-24 md:py-40"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.7 }}
                        className="md:col-span-4"
                    >
                        <div className="sticky top-32">
                            <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#FF5500]">
                                001 // Manifesto
                            </span>
                            <h2 className="mt-4 font-display font-black text-4xl md:text-5xl leading-[0.95] tracking-tight text-zinc-950">
                                Abundance is an engineering problem.
                            </h2>
                        </div>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-100px" }}
                        transition={{ duration: 0.7, delay: 0.15 }}
                        className="md:col-span-8 md:col-start-6"
                    >
                        <p className="text-2xl md:text-3xl font-display font-light text-zinc-800 leading-[1.25] tracking-tight">
                            Rane Dynamics is a veteran-founded engineering company building the
                            infrastructure for decentralized abundance. We design and prototype
                            advanced mobility platforms, Sovereign Node micro-factories, and the
                            tools that make post-scarcity possible.
                        </p>
                        <p className="mt-8 text-lg text-zinc-600 leading-relaxed max-w-3xl">
                            From the V1 electric platform to the full{" "}
                            <span className="text-zinc-950 font-semibold">Spectra // Blackline</span>{" "}
                            universe, everything we create bridges real engineering with visionary
                            storytelling. Our mission is simple: prove that abundance is not a
                            dream — it is a problem we can solve together.
                        </p>
                        <p className="mt-6 text-lg text-zinc-600 leading-relaxed max-w-3xl">
                            Founded by a disabled U.S. veteran working from the edge, Rane Dynamics
                            represents what&apos;s possible when determination meets technology.
                        </p>

                        {/* Stats grid */}
                        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-px bg-black/10 border border-black/10 rounded-2xl overflow-hidden">
                            {stats.map((s) => (
                                <div
                                    key={s.label}
                                    data-testid={`about-stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className="bg-white p-6 flex flex-col gap-3 hover:bg-[#FF5500] hover:text-white transition-colors duration-500 group"
                                >
                                    <s.icon size={22} className="text-[#FF5500] group-hover:text-white transition-colors" />
                                    <div>
                                        <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 group-hover:text-white/70 transition-colors">
                                            {s.label}
                                        </div>
                                        <div className="mt-1 font-display font-bold text-lg tracking-tight text-zinc-950 group-hover:text-white transition-colors">
                                            {s.value}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
